import { render } from "./AddCollectionModal.vue?vue&type=template&id=09be2ae9&scoped=true"
import script from "./AddCollectionModal.vue?vue&type=script&lang=js"
export * from "./AddCollectionModal.vue?vue&type=script&lang=js"

import "./AddCollectionModal.vue?vue&type=style&index=0&id=09be2ae9&lang=stylus&scoped=true"
import "./AddCollectionModal.vue?vue&type=style&index=1&id=09be2ae9&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09be2ae9"]])

export default __exports__